module.exports = __webpack_public_path__ + "img/logo.b904ff67.png";